import MultiTouch from 'mapbox-gl-multitouch';

var map = {
	selector: '[data-map]',
    init: function() {
        var self = this;

    	if ( typeof mapboxData !== "undefined" && mapboxData.hasOwnProperty( 'accessToken' ) ) {
            mapboxgl.accessToken = mapboxData.accessToken;

            $( self.selector ).each( function() {
                var $map = $( this ),
                    key  = $map.attr( 'data-map' ),
                    $triggers = $( '[data-map-jump="' + key + '"]' );

                if ( mapboxData.maps.hasOwnProperty( key ) ) {
                    var mapData = mapboxData.maps[key];

                    var map = new mapboxgl.Map( {
                        container: this,
                        style: mapboxData.style,
                        center: [mapData.center_lng, mapData.center_lat],
                        zoom: 15.4,
                        attributionControl: false,
                        scrollZoom: false,
                        boxZoom: true
                    } );

                    var nav = new mapboxgl.NavigationControl();
                    map.addControl(nav, 'top-right');
                    map.addControl(new MultiTouch());

                    if ( mapData.hasOwnProperty( 'markers' ) ) {
                        var markers   = mapData.markers,
                        markerObjects = [];

                        var i = 0;
                        var bounds = new mapboxgl.LngLatBounds();
                        var activeTarget = $triggers.filter( function() {
                            return $( this ).parent().hasClass( 'active' );
                        } ).attr( 'data-map-target' );

                        for ( var marker in markers ) {
                            var markerData = markers[marker],
                            markerEl = document.createElement('div');

                            markerEl.className = 'map__marker';
                            markerEl.setAttribute( 'data-map-target', markerData.slug );
                            markerEl.setAttribute( 'data-map-coordinates', JSON.stringify( [ markerData.map.lng, markerData.map.lat ] ) );

                            var markerInner = document.createElement('div');
                            markerInner.className = 'map__marker__inner';

                            markerEl.appendChild( markerInner );

                            if ( activeTarget ? markerData.slug === activeTarget : i === 0 ) {
                                markerEl.className = 'map__marker active';

                                if ( $( window ).width() > 992 ) {
                                    map.jumpTo({ center: [ markerData.map.lng - 0.006, markerData.map.lat + 0.000 ] });
                                } else {
                                    map.jumpTo({ center: [ markerData.map.lng, markerData.map.lat - 0.001 ] });
                                }
                            }

                            var markerObject = new mapboxgl.Marker(markerEl)
                                .setLngLat([ markerData.map.lng, markerData.map.lat ])
                                .addTo(map);

                            i++;
                        };

                        var $markers = $map.find( '.map__marker' );
                    }

                    if ( $triggers.length > 0 ) {
                        $triggers.on( 'click', function(e) {
                            e.preventDefault();

                            var $trigger = $( this ),
                            target = $trigger.attr( 'data-map-target' ),
                            $marker = $markers.filter( '[data-map-target="' + target + '"]' );

                            if ( $marker.length > 0 ) {
                                var markerCoordinates = JSON.parse( $marker.attr( 'data-map-coordinates' ) );

                                if ( $( window ).width() > 992 ) {
                                    map.jumpTo({ center: [ markerCoordinates[0] - 0.006, markerCoordinates[1] + 0.000 ] });
                                } else {
                                    map.jumpTo({ center: [ markerCoordinates[0], markerCoordinates[1] - 0.001 ] });
                                }
                                
                            }
                        } );
                    }
                }

            } )

        
        }
    }
}

export { map };